import { Helmet } from "react-helmet-async";
import { useEffect, useState, useCallback } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
// ----------------------------------------------------------------------

export default function RoundsPage() {
  const fields = [
    { title: "Name", name: "name" }, 
    { title: "Point", name: "point" }
  ];
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [competition, setCompetition] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectId, setSelectId] = useState(false);

  useEffect(() => {
    if (searchParams.has("type")) {
      const competition = searchParams.get("type");
      setCompetition(competition);
    }
  }, [searchParams]);

  const getData = (competition) => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/admin/rounds?competition=${competition}`)
      .then(function (response) {
        setLoading(false);
        setRows(response.data || []);
      });
  }

  const fn = useCallback(() => getData(competition), [competition])
  useEffect(() => {
    if(competition) fn(competition)
  }, [competition, fn])

  const selectDelete = (id) => {
    setSelectId(id);
    setOpenConfirm(true);
  };

  const deleteSubmit = () => {
    setLoading(true)
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/admin/rounds/${selectId}`)
      .then(() => getData())
      .finally(() => setLoading(false));
    setOpenConfirm(false);
    setSelectId(null);
  };

  return (
    <>
      <Helmet>
        <title> Rounds </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Rounds
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => navigate(`/dashboard/new-round?type=${competition}`)}
          >
            Create Round
          </Button>
        </Stack>
        <Card>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      {fields.map((field) => (
                        <TableCell key={field.name}>{field.title}</TableCell>
                      ))}
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {fields.map((field) => (
                          <TableCell key={field.name}>
                            {row[field.name]}
                          </TableCell>
                        ))}
                        <TableCell>
                          <Iconify
                            icon={"eva:edit-outline"}
                            sx={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(
                                `/dashboard/edit-round?roundId=${row.roundId}&type=${competition}`
                              )
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Iconify
                            icon={"eva:trash-2-outline"}
                            sx={{ cursor: "pointer" }}
                            onClick={() => selectDelete(row.roundsId)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
        <Dialog
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Are you sure you want to delete Round?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              All Round would be deleted.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
            <Button onClick={() => deleteSubmit()} autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
}
